import React from "react";
import DebtorIncome from "../../organisms/DebtorIncome";
import useStepPersistence from "../../Hooks/useStepPersistience";
const DebtorIncomeContainer = ({ formData, setFormStep, user, errors, loading, setPreviousStep, }) => {
    const [data, handleChange, handleSubmit] = useStepPersistence({
        contract_type: "",
        temporary_contract_end_date: "",
        temporary_contract_intention_to_extend: undefined,
        income_type: "",
        net_income: undefined,
        payment_frequency: "",
        income_0: undefined,
        income_1: undefined,
        income_2: undefined,
    }, formData, setFormStep);
    return (React.createElement(DebtorIncome, { setPreviousStep: setPreviousStep, onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), user: user, errors: errors, loading: loading }));
};
export default DebtorIncomeContainer;
